<template>
    <b-container fluid class="p-0">
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">Detalhes do Impedimento</span>
                    <btn-voltar />
                </h6>
            </template>
            <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold">Dados Pessoais</h6>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Tipo Pessoa</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.TpPessoa == 'F' ? 'Física' : 'Jurídica' }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>CPF/CNPJ</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.NrCpfcnpj }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Nome</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.NmNome }}</span>
                </b-col>
            </b-row>
            <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold">Dados da Proibição</h6>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Tipo do Impedimento</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.DeFundamento }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Número do Impedimento</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.NrFundamento }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Data do Impedimento</b></span>
                    <br />
                    <span class="pos-left">{{ formatData(impedimento.DtFundamento) }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Motivo / Base Legal</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.DeBaselegal }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Início da Proibição</b></span>
                    <br />
                    <span class="pos-left">{{ formatData(impedimento.DtInicioimpedimento) }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Fim da Proibição</b></span>
                    <br />
                    <span class="pos-left">{{ formatData(impedimento.DtFimimpedimento) }}</span>
                </b-col>
            </b-row>
            <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold">Dados do Registro do Protocolo</h6>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Ano/Número do Protocolo</b></span>
                    <br />
                    <span class="pos-left">{{ impedimento.deAnoNroProtocolo }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Data do Protocolo</b></span>
                    <br />
                    <span class="pos-left">{{ formatData(impedimento.DtProtocolo) }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Arquivo texto do Impedimento (PDF)</b></span><br>
                    <span class="pos-left">{{ impedimento.arquivoImpedimento?.NmArquivo }}</span>
                    <div class="wrapper-icon">
                        <btn-download :fazerDownload="() => baixarAnexoImpedimento(impedimento.arquivoImpedimento?.NmArquivo)" :texto="''" />
                    </div>
                </b-col>
            </b-row>
            <div v-if="impedimento.suspensao.DtSuspensao">
                <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold">Dados da Suspensão</h6>
                <b-row class="m-2">
                    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                        <span><b>Ano/Número Protocolo da Suspensão</b></span>
                        <br />
                        <span class="pos-left">{{ impedimento.suspensao.NrAnoprotocoloSuspensao + '/' +
                            impedimento.suspensao.NrProtocoloSuspensao
                            }}</span>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                        <span><b>Data da Suspensão</b></span>
                        <br />
                        <span class="pos-left">{{ formatData(impedimento.suspensao.DtSuspensao) }}</span>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                        <span><b>Arquivo texto da Suspensão (PDF)</b></span><br>
                        <span class="pos-left">{{ impedimento.arquivoSuspensao?.NmArquivo }}</span>
                        <div class="wrapper-icon">
                            <btn-download :fazerDownload="() => baixarAnexoSuspensao(impedimento.arquivoSuspensao?.NmArquivo)" :texto="''" />
                        </div>
                    </b-col>
                </b-row>
            </div>

        </b-card>
    </b-container>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import impedidosService from "@/services/contratacao/impedidosService"
import { Impedimentos } from "@/types/contratacao/impedimentos";

const CompProps = Vue.extend({
    name: "DetalhesImpedimento",
    components: {
        BtnVoltar, BtnDownload
    },
    props: {
        idImpedimento: {
            type: String,
            required: true
        }
    }
});

@Component
export default class DetalhesImpedimento extends mixins(UtilsTS, CompProps) {
    impedimento = new Impedimentos();
    screenBlocked = false;

    async created() {
        try {
            this.screenBlocked = true
            if (this.idImpedimento.length > 0) {
                //debug: await new Promise(r => setTimeout(r, 2000));  // js async sleep
                this.impedimento = await impedidosService.getImpedimentoId(this.idImpedimento);
            }
        }
        catch (e: any) {
            console.error('Erro ao receber dados do impedimento', e)
        }
        finally {
            this.screenBlocked = false
        }
    }

    async baixarAnexoImpedimento(nomeArquivo: string) {
        try {
            const response = await impedidosService.baixarAnexoImpedimento(this.idImpedimento);
            this.download(nomeArquivo || `arquivo-impedimento-${this.impedimento.IdImpedimento}`, response.data)
        } catch (e: any) {
            this.tratarError(e)
        }
    }

    async baixarAnexoSuspensao(nomeArquivo: string) {
        try {
            const response = await impedidosService.baixarAnexoSuspensao(this.idImpedimento);
            this.download(nomeArquivo || `arquivo-suspensao-${this.idImpedimento}`, response.data)
        } catch (e: any) {
            this.tratarError(e)
        }
    }
}

</script>

<style></style>